module.exports = __webpack_public_path__ + "img/bar-chart-square-down.10a14d3f.svg";